/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentState } from './PaymentState';
import {
    PaymentStateFromJSON,
    PaymentStateFromJSONTyped,
    PaymentStateToJSON,
    PaymentStateToJSONTyped,
} from './PaymentState';

/**
 * 
 * @export
 * @interface PaymentOpsPaymentEventDto
 */
export interface PaymentOpsPaymentEventDto {
    /**
     * 
     * @type {Date}
     * @memberof PaymentOpsPaymentEventDto
     */
    created: Date;
    /**
     * 
     * @type {PaymentOpsPaymentEventDtoEventCodeEnum}
     * @memberof PaymentOpsPaymentEventDto
     */
    eventCode: PaymentOpsPaymentEventDtoEventCodeEnum;
    /**
     * 
     * @type {number}
     * @memberof PaymentOpsPaymentEventDto
     */
    paymentId: number;
    /**
     * 
     * @type {string}
     * @memberof PaymentOpsPaymentEventDto
     */
    paymentReference: string;
    /**
     * 
     * @type {number}
     * @memberof PaymentOpsPaymentEventDto
     */
    sequence: number;
    /**
     * 
     * @type {PaymentState}
     * @memberof PaymentOpsPaymentEventDto
     */
    newState?: PaymentState | null;
    /**
     * 
     * @type {PaymentState}
     * @memberof PaymentOpsPaymentEventDto
     */
    oldState?: PaymentState | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentOpsPaymentEventDto
     */
    payload?: string | null;
}


/**
 * @export
 */
export const PaymentOpsPaymentEventDtoEventCodeEnum = {
    INITIATE: 'INITIATE',
    INITIATE_FAILED: 'INITIATE_FAILED',
    SEND_FOR_PAYMENT: 'SEND_FOR_PAYMENT',
    REDIRECT_SHOPPER: 'REDIRECT_SHOPPER',
    PAYMENT_CANCELLED: 'PAYMENT_CANCELLED',
    COMPLETE_WITHOUT_PAYMENT: 'COMPLETE_WITHOUT_PAYMENT',
    AUTHORISE: 'AUTHORISE',
    AUTHORISE_FAILED: 'AUTHORISE_FAILED',
    AUTHORISE_SUCCEEDED: 'AUTHORISE_SUCCEEDED',
    CAPTURE: 'CAPTURE',
    CAPTURE_SUCCEEDED: 'CAPTURE_SUCCEEDED',
    CAPTURE_FAILED: 'CAPTURE_FAILED',
    REFUND: 'REFUND',
    REFUND_SUCCEEDED: 'REFUND_SUCCEEDED',
    REFUND_FAILED: 'REFUND_FAILED',
    STATE_UNDETERMINED: 'STATE_UNDETERMINED',
    STATE_IN_PROGRESS: 'STATE_IN_PROGRESS',
    MANUAL_STATE_OVERRIDE: 'MANUAL_STATE_OVERRIDE'
} as const;
export type PaymentOpsPaymentEventDtoEventCodeEnum = typeof PaymentOpsPaymentEventDtoEventCodeEnum[keyof typeof PaymentOpsPaymentEventDtoEventCodeEnum];


/**
 * Check if a given object implements the PaymentOpsPaymentEventDto interface.
 */
export function instanceOfPaymentOpsPaymentEventDto(value: object): value is PaymentOpsPaymentEventDto {
    if (!('created' in value) || value['created'] === undefined) return false;
    if (!('eventCode' in value) || value['eventCode'] === undefined) return false;
    if (!('paymentId' in value) || value['paymentId'] === undefined) return false;
    if (!('paymentReference' in value) || value['paymentReference'] === undefined) return false;
    if (!('sequence' in value) || value['sequence'] === undefined) return false;
    return true;
}

export function PaymentOpsPaymentEventDtoFromJSON(json: any): PaymentOpsPaymentEventDto {
    return PaymentOpsPaymentEventDtoFromJSONTyped(json, false);
}

export function PaymentOpsPaymentEventDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentOpsPaymentEventDto {
    if (json == null) {
        return json;
    }
    return {
        
        'created': (new Date(json['created'])),
        'eventCode': json['eventCode'],
        'paymentId': json['paymentId'],
        'paymentReference': json['paymentReference'],
        'sequence': json['sequence'],
        'newState': json['newState'] === undefined ? undefined : json['newState'] === null ? null : PaymentStateFromJSON(json['newState']),
        'oldState': json['oldState'] === undefined ? undefined : json['oldState'] === null ? null : PaymentStateFromJSON(json['oldState']),
        'payload': json['payload'] === undefined ? undefined : json['payload'] === null ? null : json['payload'],
    };
}

export function PaymentOpsPaymentEventDtoToJSON(json: any): PaymentOpsPaymentEventDto {
    return PaymentOpsPaymentEventDtoToJSONTyped(json, false);
}

export function PaymentOpsPaymentEventDtoToJSONTyped(value?: PaymentOpsPaymentEventDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'created': value['created'].toISOString(),
        'eventCode': value['eventCode'],
        'paymentId': value['paymentId'],
        'paymentReference': value['paymentReference'],
        'sequence': value['sequence'],
        'newState': PaymentStateToJSON(value['newState']),
        'oldState': PaymentStateToJSON(value['oldState']),
        'payload': value['payload'],
    };
}

